export const getRootLooopAppDOMElement = () =>
  document.getElementById('looopAppRoot') as HTMLElement
